import AntdIcon from '@ant-design/icons';
import React from 'react';

export interface CreateAntdIconOptions {
  displayName?: string;
}

export function createAntdIcon(
  SvgComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>,
  options?: CreateAntdIconOptions
) {
  const IconComponent = React.forwardRef<
    HTMLSpanElement,
    React.ComponentProps<typeof AntdIcon>
  >((props, ref) => <AntdIcon {...props} ref={ref} component={SvgComponent} />);

  IconComponent.displayName = options?.displayName ?? 'CustomAntdIcon';
  return IconComponent;
}
